import Http from '../http'
export default {
  // 获取故障工单
  getFaultInfo(params) {
    return Http.post('/workOrder/list.do', params)
  },
  // 导出故障明细
  exportFaultInfo() {
    return '/workOrder/listExcel.do'
  },
  // 删除故障
  deleteFault(params) {
    return Http.post('/workOrder/delete.do', params)
  },
  // 修改故障
  editFault(params) {
    return Http.post('/workOrder/save.do', params)
  },
  // 添加工单
  addOrder(params) {
    return Http.post('/workOrder/add.do', params)
  },
  // 删除工单
  deleteOrder(params) {
    return Http.post('/newWorkOrder/delete.do', params)
  },
  // 修改工单
  editOrder(params) {
    return Http.post('/newWorkOrder/save.do', params)
  },
  // 获取工单列表
  getOrderList(params) {
    return Http.post('/newWorkOrder/list.do', params)
  },
  // 导出工单列表
  exportOrderList() {
    return '/newWorkOrder/listExcel.do'
  },
  // 获取超时工单列表
  getOverTimeWorkOrder(params) {
    return Http.post('/newWorkOrder/overTimeWorkOrder.do', params)
  },
  // 获取关闭工单列表
  getCloseList(params) {
    return Http.post('/newWorkOrder/closeList.do', params)
  },
  // 获取单个故障
  getOrder(params) {
    return Http.post('/workOrder/get.do', params)
  },
  // 获取工单状态信息
  getOrderStatusList(params) {
    return Http.post('/workOrder/getStatusList.do', params)
  },
  // 工单状态更新
  saveOrderStatusList(params) {
    return Http.post('/newWorkOrder/saveStatus.do', params)
  },
  // 关闭工单状态信息
  closeWorkOrder(params) {
    return Http.post('/newWorkOrder/closeWorkOrder.do', params)
  },
  // 获取工单响应方案
  getResponsePlan(params) {
    return Http.post('/responsePlan/get.do', params)
  },
  // 更新工单响应方案
  saveResponsePlan(params) {
    return Http.post('/responsePlan/save.do', params)
  },
  // 获取维修部门列表
  getMaintenanceList(params) {
    return Http.post('/maintenance/list.do', params)
  },
  // 获取其他营运商的维修部门列表
  getWipeMaintenanceList(params) {
    return Http.post('/maintenance/wipeList.do', params)
  },
  // 获取维修费用清单列表
  getMaintenanceCost(params) {
    return Http.post('/maintenanceCost/list.do', params)
  },
  // 删除购买记录
  deletePurchaseRecord(params) {
    return Http.post('/orderRecord/delete.do', params)
  },
  // 获取订单列表
  getOrderRecordList(params) {
    return Http.post('/orderRecord/orderList.do', params)
  },
  // 获取购买记录列表
  getPurchaseRecordList(params) {
    return Http.post('/orderRecord/purchaseRecordList.do', params)
  },
  // 报警级别分类
  getAlarmLevelList(params) {
    return Http.post('/alarmLevel/list.do', params)
  },
  // 修改报警级别分类
  saveAlarmLevelList(params) {
    return Http.post('/alarmLevel/save.do', params)
  },
  // 获取实时工单汇总
  orderStatisticsList(params) {
    return Http.post('/workOrderStatistics/list.do', params)
  },
  // 导出实时工单汇总
  exportOrderStatisticsList() {
    return '/workOrderStatistics/listExcel.do'
  },
  // 获取工单级别分布
  orderStatisticsLevellist(params) {
    return Http.post('/workOrderStatistics/Levellist.do', params)
  },
  // 导出工单汇总级别分布
  exportOrderStatisticsLevellist() {
    return '/workOrderStatistics/LevellistExcel.do'
  },
  // 获取每日变化趋势
  statisticsOrderAlarmByDay(params) {
    return Http.post('/workOrderStatistics/orderAlarmByDay.do', params)
  },
  // 导出每日变化趋势
  exportStatisticsOrderAlarmByDay() {
    return '/workOrderStatistics/orderAlarmByDayExcel.do'
  },
  // 获取累计变化趋势
  cumulativeTrend(params) {
    return Http.post('/workOrderStatistics/cumulativeTrend.do', params)
  },
  // 导出累计变化趋势
  exportCumulativeTrendExcel() {
    return '/workOrderStatistics/cumulativeTrendExcel.do'
  },
  // 获取运营商工单汇总
  orderSummary(params) {
    return Http.post('/workOrderStatistics/orderSummary.do', params)
  },
  // 导出运营商工单汇总
  orderSummaryExcel() {
    return '/workOrderStatistics/orderSummaryExcel.do'
  },
  // 获取运营商历史工单
  hisOrderSummary(params) {
    return Http.post('/workOrderStatistics/hisOrderSummary.do', params)
  },
  // 导出运营商历史工单
  hisOrderSummaryExcel() {
    return '/workOrderStatistics/hisOrderSummaryExcel.do'
  },
  // 获取运营商处理效率统计
  efficiencySummary(params) {
    return Http.post('/workOrderStatistics/efficiencySummary.do', params)
  },
  // 导出运营商处理效率统计
  efficiencySummaryExcel() {
    return '/workOrderStatistics/efficiencySummaryExcel.do'
  },
  // 更新维修部门与工单关联信息
  getUpdateMaintenanceOrder(params) {
    return Http.post('/maintenanceOrder/save.do', params)
  },
  // 订单状态
  setOrderStatus(params) {
    return Http.post('/orderRecord/orderStatus.do', params)
  },
  // 获取实时工单汇总大数据页面
  realtimeWorkOrder(params) {
    return Http.post('/workOrderIndex/realList.do', params)
  },
  // 每日变化趋势大数据页面
  everydayTrend(params) {
    return Http.post('/workOrderIndex/info.do', params)
  },
  // 固件信息列表查询
  getVehicleList(params) {
    return Http.post('/vehicle/vehicleList.do', params)
  },
  // 固件信息单个查询
  getHardwareInfo(params) {
    return Http.post('/vehicle/getHardwareInfo.do', params)
  },
  // 故障汇总大数据页面-报警列表
  getLevellist(params) {
    return Http.post('/workOrderIndex/Levellist.do', params)
  },
  // 故障汇总大数据页面-24分布
  alarm24Hour(params) {
    return Http.post('/workOrderIndex/alarm24Hour.do', params)
  },
  // 工单-维修记录
  getHisList(params) {
    return Http.post('/workOrder/hisList.do', params)
  },
  // 大数据-故障分布-左侧/中间
  failureModelIndex(params) {
    return Http.post('/model/FailureModelIndex.do', params)
  },
  // 大数据-故障分布-右侧
  getFailureModelByMouth(params) {
    return Http.post('/model/getFailureModelByMouth.do', params)
  },
  // 大数据-故障分布-机器时长
  getFailureByProDate(params) {
    return Http.post('/model/getFailureByProDate.do', params)
  },
  // 大数据-故障趋势-左上
  bigDataCumulativeTrend(params) {
    return Http.post('/workOrderIndex/cumulativeTrend.do', params)
  },
  // 大数据-故障趋势-左下
  alarmHandlingInfo(params) {
    return Http.post('/workOrderIndex/alarmHandlingInfo.do', params)
  },
  // 大数据-故障趋势-右上
  faultCondition(params) {
    return Http.post('/workOrderIndex/faultCondition.do', params)
  },
  // 大数据-故障趋势-右下
  bigDataorderSummary(params) {
    return Http.post('/workOrderIndex/orderSummary.do', params)
  },
  // 分类管理-新增
  addCategories(params) {
    return Http.post('/categories/addCategories.do', params)
  },
  // 分类管理-删除
  delCategories(params) {
    return Http.post('/categories/del.do', params)
  },
  // 分类管理-查询
  listCategories(params) {
    return Http.post('/categories/list.do', params)
  },
  // 分类管理-保存
  saveCategories(params) {
    return Http.post('/categories/saveCategories.do', params)
  },
  // 分类管理-获取
  getCategories(params) {
    return Http.post('/categories/getCategories.do', params)
  },
  // 问题发布-列表
  listQuestion(params) {
    return Http.post('/faq/list.do', params)
  },
  // 问题发布-添加
  addQuestion(params) {
    return Http.post('/faq/add.do', params)
  },
  // 问题发布-get
  getQuestion(params) {
    return Http.post('/faq/get.do', params)
  },
  // 问题发布-保存
  saveQuestion(params) {
    return Http.post('/faq/save.do', params)
  },
  // 问题发布-删除
  deleteQuestion(params) {
    return Http.post('/faq/delete.do', params)
  },
  // 获取坐席账号的企业列表
  seatUserCompanyList(params) {
    return Http.post('/company/seatUserCompanyList.do', params)
  },
  // 大数据
  workOrderStatus () {
    return Http.post('/workOrderIndex/workOrderStatus.do')
  },
  workOrderTop10 () {
    return Http.post('/workOrderIndex/workOrderTop10.do')
  },
  companyWorkOrderTop10 () {
    return Http.post('/workOrderIndex/companyWorkOrderTop10.do')
  },
  maintenanceAndWorkOrder () {
    return Http.post('/workOrderIndex/maintenanceAndWorkOrder.do')
  },
  // 生产pdf报表
  pdfReport() {
    return Http.post('/pdf/pdfReport.do')
  },
  // PDF下载列表
  pdfReportList(params) {
    return Http.post('/pdf/pdfReportList.do', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/all.js